import { TourTooltip } from './TourTooltip';
import { useOnboarding } from '@/contexts/OnboardingContext';

export function GuidedTour() {
  const {
    isActive,
    currentStep,
    currentStepIndex,
    totalSteps,
    progress,
    isFirstStep,
    isLastStep,
    nextStep,
    prevStep,
    skipTour,
  } = useOnboarding();

  if (!isActive || !currentStep) {
    return null;
  }

  return (
    <TourTooltip
      step={currentStep}
      currentIndex={currentStepIndex}
      totalSteps={totalSteps}
      progress={progress}
      isFirstStep={isFirstStep}
      isLastStep={isLastStep}
      onNext={nextStep}
      onPrev={prevStep}
      onSkip={skipTour}
    />
  );
}
